export default {
  path: 'winter-service/v2/bases/:id',
  name: 'WinterService2BaseDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/BaseDetails.vue')
}
